import * as React from 'react';
import { ContentWrapper } from '../ui/content-wrapper';
import { Loading } from '@/components/ui/loading';

type Props = {
  message: string;
};

export default class ProcessingRequestPage extends React.Component<Props> {
  render() {
    return (
      <ContentWrapper>
        <Loading message={this.props.message} />
      </ContentWrapper>
    );
  }
}
